import "../assets/styles/home.css";
import { isMobile } from "react-device-detect";

function Home() {
  return (
    <div className="home-container">
      {isMobile ? (
        <>
          <div className="logo">shriti fernando</div>
          <div className="home-image-container">
            <img
              src={require("../assets/images/backgroundfinal.jpg")}
              alt=""
            ></img>
          </div>
        </>
      ) : (
        <img src={require("../assets/images/josie5.jpg")} alt=""></img>
      )}
    </div>
  );
}

export default Home;
